import { z } from "zod";
import { MARKETS, PH_REGIONS } from "../constants/market.js";

/**
 * PUT /api/account/region body — "Where is your family based?". The SAME
 * schema validates the server request and drives the client form, so their
 * errors match.
 *
 *  - Philippines (`ph`): a city from PH_REGIONS is required.
 *  - United States & elsewhere (`main`): no city — whatever was sent is
 *    forced to null, so a stale city can never linger on a main account.
 */
export const accountRegionSchema = z
  .object({
    market: z.enum(MARKETS, { errorMap: () => ({ message: "Choose where your family is based" }) }),
    phRegion: z
      .enum(PH_REGIONS, { errorMap: () => ({ message: "Choose your city" }) })
      .nullable()
      .optional(),
  })
  .superRefine((value, ctx) => {
    if (value.market === "ph" && !value.phRegion) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["phRegion"],
        message: "Choose your city",
      });
    }
  })
  .transform((value) => ({
    market: value.market,
    phRegion: value.market === "ph" ? (value.phRegion ?? null) : null,
  }));

export type AccountRegionInput = z.input<typeof accountRegionSchema>;
export type AccountRegionValue = z.output<typeof accountRegionSchema>;
